<template>
  <el-dialog
    title="案件全文"
    :visible.sync="visible"
    :width="categoryArr.length > 0 ? '920px' : '720px'"
    :before-close="() => (visible = false)"
    :append-to-body="true"
  >
    <div class="article-modal">
      <div class="category-content" v-if="categoryArr.length > 0">
        <div class="category-title">
          <div class="iconfont iconhang"></div>
          <span>目录</span>
        </div>
        <div
          class="category-item"
          :class="currentCategory === categoryItem ? 'is-pick' : ''"
          v-for="(categoryItem, categoryIndex) in categoryArr"
          :key="`${categoryItem.paragraphKey}_${categoryIndex}`"
          @click="tapCategoryHandle(categoryItem)"
        >
          <span>{{ categoryItem.titleText }}</span>
        </div>
      </div>
      <div class="article-content" id="articleContent">
        <div v-for="(item, index) in tableTextArr" :key="index" class="text-content">
          <div :style="item.isTitle ? {} : { 'text-indent': '2em' }">
            <template v-if="item.isTitle">
              <div class="paragraph-title" :id="item.paragraphKey">
                <span>{{ item.titleText }}</span>
              </div>
            </template>
            <template v-else v-for="subItem in item.tagArr">
              <tag-text v-if="subItem.isTag" :key="subItem.textId" :text="subItem.text" :tagItem="subItem" />
              <span v-else-if="subItem.isHigh" :key="subItem.textId" class="search-text-high">
                <span>{{ subItem.text }}</span>
              </span>
              <template v-else>
                <span :key="subItem.textId">
                  <span>{{ subItem.text }}</span>
                </span>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import TagText from '@/views/dataCleaner/components/tagText';

import {
  fetchExistsTagPositionArr,
  fetchTextArr,
  formatPeriodHandle,
  formatSpecialSymbol,
  fetchParagraphIndex,
  fetchTagTextIndex,
  fetchNextTagItem
} from '@/views/dataCleaner/components/lib/labelCalculator';
import { services } from '@/service';

export default {
  components: { TagText },
  data() {
    return {
      currentCategory: null,
      paragraphArr: []
    };
  },
  props: {
    courseId: {
      type: String,
      required: true
    },
    rowDetail: {
      type: Object,
      required: true
    },
    currentRuleArr: {
      type: Array,
      default: () => []
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    },
    tableTextArr() {
      if (this.paragraphArr.length < 1) {
        return [];
      }
      const arr = formatSpecialSymbol([
        this.initTableTextArr({
          rowDetail: this.rowDetail,
          currentRuleArr: this.currentRuleArr
        })
      ]);
      return (arr[0] || {}).textArr || [];
    },
    categoryArr() {
      return this.tableTextArr.filter(item => item.isTitle);
    }
  },
  watch: {
    categoryArr: {
      handler(val) {
        if (val[0]) {
          this.currentCategory = val[0];
        }
      }
    }
  },
  async mounted() {
    this.paragraphArr = await services.labelRelation.getParagraph(this.courseId);
  },
  methods: {
    tapCategoryHandle(category) {
      if (this.currentCategory === category) {
        return;
      }
      this.currentCategory = category;
      const contentEl = window.document.getElementById('articleContent');
      const textEl = window.document.getElementById(category.paragraphKey);
      const offsetTop = textEl.offsetTop - contentEl.offsetTop;
      contentEl.scrollTop = offsetTop;
    },
    initTableTextArr(params) {
      const { rowDetail, currentRuleArr } = params;
      // 获取有效的标注
      const tagPositionArr = fetchExistsTagPositionArr({ currentRuleArr, rowDetail });

      // 如果需要精准的获取到 段落的key，则需要传入 instrumentType 来过滤分组，参考数据清洗的 caseLabelEditor
      const paragraphTitleEnumFilter = {};
      this.paragraphArr.forEach(paragraphItem => {
        paragraphTitleEnumFilter[paragraphItem.value] = paragraphItem;
      });

      // 获取段落及段落内容
      let textArr = fetchTextArr({ rowDetail, paragraphTitleEnumFilter });

      // 按句号分割
      textArr = formatPeriodHandle(textArr);

      // 根据tag的start位置和每段的长度判断在哪行
      tagPositionArr.forEach(tagPositionItem => {
        if (tagPositionItem.start >= tagPositionItem.end) {
          return;
        }

        // 根据标注位置获取所在的段落index
        const currentParagraphIndex = fetchParagraphIndex({ textArr, tagPositionItem });

        // true代表标注文本跨段落
        if (currentParagraphIndex < 0) {
          return;
        }

        const { tagArr } = textArr[currentParagraphIndex];

        // 获取段落内文本span的index
        let currentTagTextIndex = fetchTagTextIndex({ tagArr, tagPositionItem });

        if (currentTagTextIndex < 0) {
          return;
        }

        let currentItem = tagArr[currentTagTextIndex];

        // 如果需要在已有tag-text内渲染则需要从下一个span-text开始渲染，并记录该tag原始的start
        if (currentItem.isTag) {
          const newTagIndex = fetchNextTagItem({ currentTagTextIndex, tagArr });

          if (newTagIndex === -1) {
            return;
          }

          currentTagTextIndex = newTagIndex;
          currentItem = tagArr[newTagIndex];
          tagPositionItem.start = currentItem.start;

          if (tagPositionItem.start >= tagPositionItem.end) {
            return;
          }
        }

        const currentItemText = currentItem.text;
        const sameStart = tagPositionItem.start === currentItem.start;
        const haveNextItem = tagPositionItem.end < currentItem.start + currentItem.text.length;
        let nextIndex = -1;

        let tagItemText = '';

        // 将tag-span塞进去，判断前后文本怎么处理
        if (sameStart) {
          tagItemText = currentItemText.slice(0, tagPositionItem.end - tagPositionItem.start);
          tagArr.splice(currentTagTextIndex, 1, {
            id: tagPositionItem.id,
            textId: `${tagPositionItem.start}_${tagItemText.length}`,
            isTag: true,
            text: tagItemText,
            start: tagPositionItem.start,
            columnKey: tagPositionItem.columnKey,
            columnTitle: tagPositionItem.columnTitle,
            columnFullName: tagPositionItem.columnFullName,
            fieldThemeName: tagPositionItem.fieldThemeName
          });
          nextIndex = currentTagTextIndex + 1;
        } else {
          currentItem.text = currentItemText.slice(0, tagPositionItem.start - currentItem.start);
          currentItem.textId = `${currentItem.start}_${currentItem.text.length}`;
          currentItem.splitByHigh = true;
          tagItemText = currentItemText.slice(
            tagPositionItem.start - currentItem.start,
            tagPositionItem.end - currentItem.start
          );
          tagArr.splice(currentTagTextIndex + 1, 0, {
            id: tagPositionItem.id,
            textId: `${tagPositionItem.start}_${tagItemText.length}`,
            isTag: true,
            text: tagItemText,
            start: tagPositionItem.start,
            columnKey: tagPositionItem.columnKey,
            columnTitle: tagPositionItem.columnTitle,
            columnFullName: tagPositionItem.columnFullName,
            fieldThemeName: tagPositionItem.fieldThemeName
          });
          nextIndex = currentTagTextIndex + 2;
        }
        if (haveNextItem && nextIndex > -1) {
          const nextItemText = currentItemText.slice(tagPositionItem.end - currentItem.start);
          tagArr.splice(nextIndex, 0, {
            textId: `${tagPositionItem.start + tagItemText.length}_${nextItemText.length}`,
            isTag: false,
            text: nextItemText,
            start: tagPositionItem.start + tagItemText.length,
            splitByHigh: true
          });
        }
      });

      return textArr;
    }
  }
};
</script>

<style lang="scss" scoped>
.article-modal {
  display: flex;
  align-items: flex-start;

  .category-content {
    box-sizing: border-box;
    width: 200px;
    height: $dialogBodyMaxHeight;
    overflow-y: auto;
    overflow-x: hidden;
    border-right: 1px solid #d9dde4;
    padding: 10px;
    padding-top: 0;

    .category-title {
      color: #3d465a;
      font-size: 14px;
      height: 22px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .iconfont {
        font-size: 20px;
        margin-right: 4px;
      }
    }
    .category-item {
      box-sizing: border-box;
      position: relative;
      color: #3d465a;
      font-size: 14px;
      height: 22px;
      line-height: 22px;
      margin-bottom: 10px;
      padding-left: 24px;
      cursor: pointer;

      &::before {
        content: ' ';
        position: absolute;
        left: 5px;
        top: 8px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #3d465a;
      }

      &.is-pick {
        color: #0c93f2;

        &::before {
          background-color: #0c93f2;
        }
      }
    }
  }

  .article-content {
    box-sizing: border-box;
    flex: 1;
    width: 0;
    max-height: $dialogBodyMaxHeight;
    line-height: 22px;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 10px;
    padding-top: 0;

    ::v-deep .article-item {
      .paragraph-title {
        position: relative;
        font-size: 14px;
        margin: 20px 0 6px;
        padding-left: 8px;

        &::before {
          content: ' ';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 55%;
          border-radius: 30px;
          background-color: #0d7de0;
        }

        & > span {
          font-weight: 600;
        }
      }

      .paragraph-text {
        text-indent: 2em;
      }

      &:first-child {
        .paragraph-title {
          margin-top: 0;
        }
      }
    }
  }

  .text-content {
    font-size: 14px;
    line-height: 24px;
    white-space: break-spaces;

    .search-text-high {
      background-color: #ee813b;
      color: #fff;
    }
    .paragraph-title {
      position: relative;
      font-size: 14px;
      margin: 20px 0 4px;
      padding-left: 8px;

      &::before {
        content: ' ';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 55%;
        border-radius: 30px;
        background-color: #0d7de0;
      }

      & > span {
        font-weight: 600;
      }
    }
    &:first-child {
      .paragraph-title {
        margin-top: 0;
      }
    }
  }
}
</style>
